import { VStack } from '@adc/parallax-component-library';

function ContentContainer({ children }: React.PropsWithChildren) {
  return (
    <VStack padding="$4" paddingTop="$2" gap="$4">
      {children}
    </VStack>
  );
}

export { ContentContainer };
